export default function generateDynamicId() {
  return `id-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
}
